import type { RouterConfig } from '@nuxt/schema'

export default {
  // https://router.vuejs.org/api/interfaces/routeroptions.html#routes
  routes: (routes) => [
    {
      path: '/file-submission/:id',
      redirect: (to) => ({
        path: to.path.replace('file-submission', 'submission'),
      }),
    },
    ...routes,
  ],
} satisfies RouterConfig
